import React from 'react';
import { Button } from 'react-bootstrap';
import style from './FloatingBtn.module.css';
import { FaPlus } from "react-icons/fa6";

const FloatingBtn = ({ handleShowAddModal }) => {
  return (
    <Button variant="primary" className={style.floatingBtn} onClick={handleShowAddModal}>
      <FaPlus />
    </Button>
  )
}

export default FloatingBtn;